export default "__VITE_ASSET__DbmuzJoi__"